import { gql } from 'apollo-angular';

/**
 * Dongle schema
 */
export class DongleSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		dongleId
	`;

	/**
	 * Get dongles
	 */
	static readonly getDongleList = gql`
		query GetDongleList($filters: [WhereFilter], $pageIndex: Int, $resultsPerPage: Int, $orderBy: String, $isAscending: String) {
			donglelist(filters: $filters, pageIndex: $pageIndex, resultsPerPage: $resultsPerPage, orderBy: $orderBy, isAscending: $isAscending) {
				totalCount
				list {
					${DongleSchema.topLevelProperties}
				}
			}
		}
	`;

	/**
	 * Remove dongle
	 */
	static readonly removeDongle = gql`
		mutation RemoveDongle($dongleId: String!) {
			removeDongle(dongleId: $dongleId) {
				${DongleSchema.topLevelProperties}
			}
		}
	`;
}
